import React from 'react';
import type { BoardLinkListBaseProps, BoardLinkSearchItem } from './boardLinkTypes';
import { GridList } from 'react-aria-components';
import BoardLinkListItem from './BoardLinkListItem';

type BoardLinkListProps = BoardLinkListBaseProps & {
    items: BoardLinkSearchItem[];
    size?: 'sm' | 'lg';
};

const BoardLinkList: React.FC<BoardLinkListProps> = ({ items, gridSize, onSelect, isSheet, size }) => {
    return (
        <div className="BoardLinkList">
            <GridList aria-label="Board links" className="w-full min-w-0 outline-hidden">
                {items.map((item) => (
                    <BoardLinkListItem
                        key={item.boardId}
                        item={item}
                        gridSize={gridSize}
                        onSelect={onSelect}
                        isSheet={isSheet}
                        size={size}
                    />
                ))}
            </GridList>
        </div>
    );
};

export default BoardLinkList;
